var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2071 0.292893C10.8166 -0.0976311 10.1834 -0.0976311 9.79289 0.292893L0.792893 9.29289C0.402369 9.68342 0.402369 10.3166 0.792893 10.7071C1.18342 11.0976 1.81658 11.0976 2.20711 10.7071L2.5 10.4142V18C2.5 18.5523 2.94772 19 3.5 19H8.5C9.05228 19 9.5 18.5523 9.5 18V13H11.5V18C11.5 18.5523 11.9477 19 12.5 19H17.5C18.0523 19 18.5 18.5523 18.5 18V10.4142L18.7929 10.7071C19.1834 11.0976 19.8166 11.0976 20.2071 10.7071C20.5976 10.3166 20.5976 9.68342 20.2071 9.29289L11.2071 0.292893ZM16.5 8.41421L10.5 2.41421L4.5 8.41421V17H7.5V12C7.5 11.4477 7.94772 11 8.5 11H12.5C13.0523 11 13.5 11.4477 13.5 12V17H16.5V8.41421Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.3cb2677cbcd130b1e91e6ad3cb4db46e.svg";
export { ForwardRef as ReactComponent };